jQuery(document).ready(function () {



		/**
	 * plyr setup
	 * @link https://github.com/sampotts/plyr
	 * @link https://github.com/sampotts/plyr#multiple-players
	 */

	const players = Array.from(document.querySelectorAll('.js-videoplayer')).map(p => new Plyr(p, {
		playsinline: true,
		controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen']
	}));
	if(window.gtag) {
		function regStart(player) {
			player.on('playing', () => {
				gtag('event', 'video_start', {
					video_url: player.source,
					video_duration: player.duration
				});
				player.off('playing');
			});
		}
		players.forEach((player) => {
			regStart(player);
			player.on('ended', () => {
				gtag('event', 'video_complete', {
					video_url: player.source,
					video_duration: player.duration
				});
			});
			let lastPercentage = 0;
			player.on('timeupdate', () => {
				let percentagePlayed = (player.currentTime / player.duration) * 100;
				if((percentagePlayed > 10 && lastPercentage < 10) ||
					(percentagePlayed > 25 && lastPercentage < 25) ||
					(percentagePlayed > 50 && lastPercentage < 50) ||
					(percentagePlayed > 75 && lastPercentage < 75)) {
					//A note: if a visitor skips to a certain percentage over a threshold (say, from 45% to 55%), the video_percent will be registered as whatever they skipped to
					gtag('event', 'video_progress', {
						video_url: player.source,
						video_duration: player.duration,
						video_current_time: player.currentTime,
						video_percent: percentagePlayed
					});
				}
				lastPercentage = percentagePlayed;
			});
		});
	}



	/**
	 * breakpoints for responsivness
	 * @link https://github.com/jerrylow/breakpoints
	 */

	jQuery(window).breakpoints({
		breakpoints: [{
			"name": "sm",
			"width": 576
		}, {
			"name": "md",
			"width": 768
		}, {
			"name": "lg",
			"width": 992
		}, {
			"name": "xl",
			"width": 1200
		}]
	});

	/**
	 * detects external links and adds target="_blank"
	 */

	var host = window.location.host;

	jQuery('a').not('[href*="' + host + '"]').filter(function () {
		return this.hostname && this.hostname !== location.hostname;
	}).attr('target', '_blank').attr('rel', 'noopener');


	/**
	 * faq
	 */

	jQuery('.js-faq-question').on('click', function () {
		if ($(this).find('.js-faq-icon').hasClass('jam-minus'))
			$(this).siblings('.js-faq-answer').slideToggle('close');
		else if ($(this).find('.js-faq-icon').hasClass('jam-plus'))
			$(this).siblings('.js-faq-answer').slideToggle('open');
		jQuery(this).siblings('.js-faq-answer').toggleClass('hidden');
		jQuery(this).parent('li').toggleClass('pb-0');
		jQuery(this).find('.js-faq-icon').toggleClass('jam-minus');
		jQuery(this).find('.js-faq-icon').toggleClass('jam-plus');

	});


	/**
	 * smooth scroll
	 */

	function smoothScrollAnchor(el,event) {
		var target = $(el.hash);
		target = target.length ? target : $('[name=' + el.hash.slice(1) + ']'); // Does a scroll target exist?
		if (target.length) {
        // Only prevent default if animation is actually gonna happen
			event.preventDefault();
			$('html, body').animate({
			  scrollTop: target.offset().top - 130
			}, 1000, function () {
			  // Callback after animation
			  // Must change focus!
			  var $target = $(target);
			  $target.focus();
			  if ($target.is(":focus")) {
				// Checking if the target was focused
				return false;
			  } else {
				$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
				$target.focus(); // Set focus again
			  };
			});
		}
	}
  jQuery('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function (event) {
    // On-page links
    if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      // Figure out element to scroll to
	  smoothScrollAnchor(this,event);
    }
  });


	/**
	 * fixed page menu
	 */

	if ($('.js-page-navigation').length > 0) {
		let left_pos = $($('.js-page-navigation').parent())[0].getBoundingClientRect().left;
		let org_width = $($('.js-page-navigation').parent())[0].getBoundingClientRect().width;
		$(window).on('scroll', function () {
			checkScroll(left_pos,org_width);
		});
		$(window).on('resize', function () {
			if ($('.js-page-navigation').length > 0) {
				if ($('#block-top').length == 1) {
					left_pos = $($('#block-top .js-page-navigation').parent())[0].getBoundingClientRect().left;
					org_width = $($('#block-top .js-page-navigation').parent())[0].getBoundingClientRect().width;
				} else {
					left_pos = $($('.js-page-navigation').parent())[0].getBoundingClientRect().left;
					org_width = $($('.js-page-navigation').parent())[0].getBoundingClientRect().width;
				}
			}
			checkScroll(left_pos,org_width);
		});
	}

	function scrollLeftMenu(left_pos,org_width) {
		let scrolltop = $(window).scrollTop();
		if ($('.js-page-navigation').length > 0) {
			if ($('#block-top').length == 0 && $('#block-bottom').length == 0) {
				$('.js-page-navigation').parent().attr('id','block-top');
				let new_menu = $('#block-top').clone();
				$(new_menu).insertAfter($('main'));
				$(new_menu).attr('id','block-bottom');
				$('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(e){
					if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
					  smoothScrollAnchor(this,e);
					}
				});
			} else {
				$('#block-top').css('opacity','1');
				$('#block-bottom').css({
					'display':'block',
					'height':'0'
				});
			}
			var next_el = $('#block-top').next();
			if($(next_el).hasClass('components-templates-glossary-glossary-navigation')) {
				next_el = $(next_el).next();
			}
			if (scrolltop <= $(next_el).offset().top) {
				$('#block-top').css('opacity','1');
				$('#block-bottom').css('display','none');
			} else {
				$('#block-top').css('opacity','0');
				$('#block-bottom').css({
					'display':'block',
					'height':'0'
				});
				if (scrolltop + $('#block-bottom .js-page-navigation').height() + 300 < $('footer').offset().top) {
					$('#block-bottom .js-page-navigation').css({
						'position': 'fixed',
						'top': '120px',
						'left': left_pos + 20 + 'px',
						'padding-left': '1rem',
						'padding-right': '3rem',
						'bottom': 'auto',
						'z-index': '10',
						'width': org_width - 10 + 'px'
					});
				} else {
					$('#block-bottom .js-page-navigation').css({
						'position': 'absolute',
						'top': 'auto',
						'left': left_pos + 20 + 'px',
						'bottom': '0',
						'padding-left': '1rem',
						'padding-right': '3rem'
					});
				}
			}
		}
	}

	function checkScroll(left_pos,org_width) {
		if ($(window).width() < 992) {
			if ($('.js-page-navigation').length > 0 && ($('#block-top').length == 1 || $('#block-bottom').length == 1)) {
				$('#block-bottom').css('display','none');
				$('#block-top').css('opacity','0');
			}
		} else {
			scrollLeftMenu(left_pos,org_width);
		}
	}




	$(".jam-close").click(function (e) {
		e.preventDefault();
		//$(".newsletter-subscription-container").addClass('block');
		$(this).parent('.bg-siren').parent('.newsletter-subscription-container').removeClass('block');


	});

	$(".subscribe-form").click(function (e) {
		e.preventDefault();
		$(".newsletter-subscription-container").addClass('block');

	});



});







